export default "__VITE_ASSET__CyIj9Ytk__"